import React, {Component} from 'react'
import ConnectedComponent from '../../../../shared/connecter/ConnectedComponent'
import SimpleModalComponent from '../../../../shared/modal/SimpleModalComponent'
import {LevelContainer, ScoreContainer} from '../../containers/LevelContainer'
import {DiceScorePad, BlankKey} from './SharedLevelComponent'

class ScoreKey extends Component {
    triggerScore = () => {
        const {value} = this.props
        if (this.props.onChange) this.props.onChange(value)
    }

    render() {
        const {value} = this.props
        return (
            <div className="col-md-4 col-sm-4 col-xs-4 text-center padkey" onClick={this.triggerScore}>
                {value === -1 ? <i className="fa fa-chevron-left"/> : value }
            </div>
        )
    }
}


class ScorePad extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: (props.score || '') + ''
        }
    }

    triggerScore = (v) => {
        if (v === 'x') {
            if (this.props.onChange) this.props.onChange(v)
        } else {
            let value = this.state.value
            if (value && v === -1) {
                const _v = value.split('')
                _v.pop()
                value = _v.join('')
            } else if (v >= 0) {
                value = value + '' + v
            }
            this.setState({
                value
            })

            //if(this.props.onChange) this.props.onChange(value ? parseInt(value, 10) : 0)
        }

    }

    submit = () => {
        const {value} = this.state
        if (this.props.onChange) this.props.onChange(value ? parseInt(value, 10) : 0)
    }


    render() {
        //const {key} = this.props.conf.config
        const keys = []
        for (let i = 1; i < 10; i++) {
            keys.push(<ScoreKey onChange={this.triggerScore} key={'pad-' + i} value={i}/>)
        }
        keys.push(<ScoreKey onChange={this.triggerScore} key={'pad-back'} value={-1}/>)
        //keys.push(<BlankKey key={'pad-blank-l'} />)
        keys.push(<ScoreKey onChange={this.triggerScore} key={'pad-' + 0} value={0}/>)
        keys.push(<BlankKey key={'pad-blank-r'} />)


        //if (this.props.deleteKey) keys.push(<DeleteScoreKey size={4} onChange={this.triggerScore} key={'pad-x'} value={'x'}/>)
        //else keys.push(<BlankKey key={'pad-x'}/>)

        return (
            <div className="row">
                <div className="col-md-6 col-sm-6 col-xs-6 text-center">
                    <div className="padvalue">
                        {this.state.value}
                        <br />
                        <button onClick={this.submit} style={{padding: '6px 50px'}} className="btn btn-success">OK
                        </button>
                    </div>
                </div>
                <div className="col-md-6 col-sm-6 col-xs-6">
                    <div className="row pad">
                        {keys}
                    </div>
                </div>
            </div>
        )
    }
}



class PadScorePadWrapper extends Component {
    render() {
        return (<DiceScorePad onChange={this.props.onChange}>
            {this.props.children}
        </DiceScorePad>)
    }
}


//
// class DiceScorePadWrapper extends Component {
//     constructor() {
//         super()
//         this.state = {
//             picked: []
//         }
//
//     }
//
//     triggerScore = (v) => {
//         if (this.props.onChange)  this.props.onChange(v)
//     }
//     add = (v) => {
//         if (this.state.picked.length < 5)
//             this.setState({
//                 picked: this.state.picked.concat(v)
//             })
//     }
//     remove = (v) => {
//         const p = this.state.picked
//         this.setState({
//             picked: p.slice(0, v).concat(p.slice(v + 1))
//         })
//     }
//     processScore = (v, idxRemove) => {
//
//         if (typeof idxRemove === 'number') {
//             this.remove(idxRemove)
//             return
//         }
//         this.add(v)
//     }
//
//     render() {
//         return (<DiceScorePad onChange={this.triggerScore}>
//             {/*<ScorePad  onChange={this.triggerScore} conf={this.props.conf} />*/}
//             <DicePad picked={this.state.picked} onChange={this.processScore}/>
//             <br /><br />
//             <DicePad style={{transform: 'scale(.7)'}} onChange={this.processScore}/>
//         </DiceScorePad>)
//     }
//
//     componentDidUpdate() {
//         if (this.state.picked.length === 5) {
//             setTimeout(()=> {
//                 this.triggerScore(this.state.picked.reduce((p, v)=> p + v), 0)
//             }, 300)
//
//         }
//     }
// }

class ScoreComponent extends Component {

    constructor() {
        super()
        this.state = {
            edit: false
        }
    }

    triggerScore = (v) => {
        const {player, conf} = this.props
        if (this.props.onChange) this.props.onChange(player, conf, v !== 'x' && v > 0 ? v + conf.config.bonus : v)
        //if () this.toggleEditScore(false)
        this.toggleEditScore(false)
        //if (v === 'x' ||  (v + '').length === 2) this.toggleEditScore(false)
    }

    editScore = () => {
        const {player, conf} = this.props

        //TODO SKIPPING DICE MODE
        // MUST FIND A BETTER WAY
        // const content = mode === 'dices' ?
        //     <DiceScorePadWrapper onChange={this.triggerScore} conf={this.props.conf}/> :
        //     <ScorePad onChange={this.triggerScore} conf={this.props.conf} deleteKey={true}/>

        const content = <PadScorePadWrapper onChange={this.triggerScore}>
            <ScorePad onChange={this.triggerScore} conf={this.props.conf} deleteKey={true}/>
            </PadScorePadWrapper>

        return this.state.edit ?
            <SimpleModalComponent title={conf.config.name + ' pour ' + player.name } content={content}
                                  close={e=>this.toggleEditScore(false)}/> : null
    }

    toggleEditScore = (status) => {
        this.setState({
            edit: typeof status !== 'undefined' ? status : !this.state.edit
        })
    }

    render() {
        const {player, conf} = this.props
        const _score = player.scoreBoard.find(o => o.id === conf.id)
        const score = _score ? _score.value : 0

        return (<ScoreContainer level={this.props.conf}>
            {this.editScore()}
            <span onClick={this.toggleEditScore}>{_score ? score || '/' : ''}</span>
        </ScoreContainer>)
    }
}


export default class CustomLevelComponent extends ConnectedComponent {

    constructor() {
        super()
        this.subscribe('players')
    }

    saveScore = (player, level, v) => {
        const playerScoreBoard = this.store.players.get(player.id).get('scoreBoard').filter(s => s.id !== level.id)
        if (v !== 'x') {
            playerScoreBoard.push({id: level.id, value: v})
        }
        this.store.players.get(player.id).set('scoreBoard', playerScoreBoard)
    }

    render() {

        const level = this.props.level
        const scores = this.store.players.toJSON().map(player => {
            return <ScoreComponent mode={this.store.settings.get('mode')} onChange={this.saveScore} key={player.id}
                                   player={player} conf={level}/>
        })

        return (<LevelContainer bonus={level.config.bonus} className={this.props.className}
                                name={level.config.name}>{scores}</LevelContainer>)
    }
}


// WEBPACK FOOTER //
// ./src/game/level/components/types/CustomLevelComponent.jsx